import openkit from "openkit";
import { API_URL } from "../config/config";
openkit.config.openkit_url = API_URL;

// const createUser = async (user) => {
//   // await openkit.data.create("users", user);
//   try {
//     const u = await openkit.users.createUser(user);
//     // createUser(user);
//     console.log("u :>> ", u);
//   } catch (error) {
//     console.log("error :>> ", error);
//   }
// };

// const loginUser = async (user) => {
//   return await openkit.auth.loginWithEmailAndPassword(
//     user.email,
//     user.password
//   );
// };

const logoutUser = async (user) => {
  return await openkit.auth.logout();
};

const getLoggedInUser = async () => {
  const resp = await openkit.auth.getLoggedInUser();
  return resp;
};

const loginWithGoogleToken = async (token) => {
  const result = await openkit.auth.loginWithGoogleToken(token);
  if (!result) return;
  const user = await getLoggedInUser();
  return user;
};

const loginWithFacebookToken = async (token) => {
  const resp = await openkit.auth.loginWithFacebookToken(token);
  return resp;
};

const updateUser = async (id, data) => {
  const resp = await openkit.data.update("users", id, data);
  return resp;
};

export {
  // createUser,
  // loginUser,
  logoutUser,
  getLoggedInUser,
  loginWithGoogleToken,
  loginWithFacebookToken,
  updateUser,
};
